import React from 'react';
import * as S from './MainSider/MainSider.styles';
import { RightOutlined } from '@ant-design/icons';
import { useResponsive } from 'hooks/useResponsive';
import { useLocation } from 'react-router-dom';

import { getLogoTitle } from '@app/services/localStorage.service';
interface SiderLogoProps {
  isSiderCollapsed: boolean;
  toggleSider: () => void;
}
export const SiderLogo: React.FC<SiderLogoProps> = ({ isSiderCollapsed, toggleSider }) => {
  const { mobileOnly, tabletOnly } = useResponsive();
  const location = useLocation();
  const factory = location.pathname.split('/')[1];

  if (factory === 'calib') {
    return (
      <S.CalibLogoWrapper>
        <h3>TOOL MANAGEMENT</h3>
      </S.CalibLogoWrapper>
    );
  }

  return (
    <>
      {factory === 'spa' ? (
        <h3 style={{ textAlign: 'center', marginTop: '25px', color: '#fff', fontSize: '1.3em' }}>Spacer</h3>
      ) : (
        <>
          {!mobileOnly && factory === 'fac' && (
            <S.CollapseButton
              shape="circle"
              size="small"
              $isCollapsed={isSiderCollapsed}
              icon={<RightOutlined rotate={isSiderCollapsed ? 0 : 180} />}
              onClick={toggleSider}
            />
          )}
          <h3 style={{ textAlign: 'center', marginTop: '25px', color: '#fff', fontSize: '1.3em' }}>
            {factory === 'fac' ? 'FAC Factory' : getLogoTitle(factory)}
          </h3>
        </>
      )}
    </>
  );
};
